import BetErrorsImpl from './bet-errors.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display bet errors in single bet.
 *
 * @class BetErrors
 * @memberof Mojito.Modules.BetslipView.BetComponents
 */

/**
 * BetErrors prop types.
 *
 * @property {Array<Mojito.Services.Betslip.types.Error>} [errors] - Bet errors.
 * @memberof Mojito.Modules.BetslipView.BetComponents.BetErrors
 */
const propTypes = {
    errors: PropTypes.array,
};

const defaultProps = {
    errors: [],
};

export default UIView('BetErrors', BetErrorsImpl, propTypes, defaultProps);
